<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" >
      <b-col md="10" lg="8" xl="6">
        <b-card>
          <div slot="header">{{$route.meta.label}}
            <div class="card-header-actions">
              <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="print()">
                <i class="fa fa-print"></i> Print
              </button>
              <b-button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Batal
              </b-button>
            </div>
          </div>

          <b-input-group>
            <b-input-group-prepend><label >Tanggal Kirim</label></b-input-group-prepend>
            <b-form-input
              class="col-md-6"
              v-model="model.tanggal"
              type="date"
              :state="!$v.model.tanggal.$error"
            ></b-form-input>
            <b-form-checkbox  v-model="isPrintedForm" value="1" unchecked-value="0" class="ml-4 p-2">Cetak pd Preprinted Form</b-form-checkbox>            
          </b-input-group>
          <b-row>
            <b-col cols="8">
                <h6>Eksemplar per Koli per Section</h6>
            </b-col>
            <b-col cols="4">
                <b-form-checkbox  v-model="sectionPrinted" value="1" unchecked-value="0" >Nama Section ikut dicetak</b-form-checkbox>            
            </b-col>
          </b-row>
            <b-row no-gutters>
              <b-col cols="4">
                <b-input-group id="section_no">
                  <b-input-group-prepend >
                    <span class="p-2">Section No:</span>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="model.section_no"
                    :options="options_section_no"
                    :state="!$v.model.section_no.$error"
                    :plain="true"
                  ></b-form-select>
                  <b-form-invalid-feedback id="input-1-live-feedback">Pilih salah satu section.</b-form-invalid-feedback>
                </b-input-group>
              </b-col>
              <b-col cols="8">
                <b-input-group>
                  <b-input-group-prepend >
                    <span class="p-2">Normal:</span>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="model.koliNormal"
                    :state="!$v.model.koliNormal.$error"
                    class="col-6"
                  ></b-form-input>
                  <b-form-invalid-feedback>Minimal: {{$v.model.koliNormal.$params.minValue.min}}.</b-form-invalid-feedback>
                  <b-input-group-prepend >
                    <span class="p-2">Minimum:</span>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.koliMinimum" :state="!$v.model.koliMinimum.$error"></b-form-input>
                  <b-input-group-prepend >
                    <span class="p-2">Toleransi:</span>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="model.koliToleransi"
                    :state="!$v.model.koliToleransi.$error"
                  ></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>

          <h6>Pilih Agen/Jurusan  </h6>
          <b-input-group>
              <b-form-radio v-model="filterAgenJurusan"  value="AGEN" class="pt-2" >Agen </b-form-radio>                
              <b-form-input
                v-model="customer_info"
                placeholder="Cari kode atau nama agen."
                readonly v-if="(filterAgenJurusan=='AGEN')"
              ></b-form-input>
              <b-input-group-append v-if="(filterAgenJurusan=='AGEN')">
                <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>

          </b-input-group>
          <b-row no-gutters>
            <b-col lg="7">  
              <b-input-group>
                  <b-form-radio v-model="filterAgenJurusan"  value="JURUSAN" class="pt-2">Jurusan </b-form-radio>                
                <b-form-input v-model="findJurusan" placeholder="masukkan nama/kode jurusan" v-if="(filterAgenJurusan=='JURUSAN')"></b-form-input>
                <b-input-group-append>
                    <b-button class="btn btn-secondary" @click="clearFilter()" v-if="(filterAgenJurusan=='JURUSAN')" ><i class="fa fa-close"></i></b-button>               
                </b-input-group-append>
                <b-form-invalid-feedback style="display:unset; font-size: 90%;" v-show="isRequiredJurusan">Pilih minimal 1 jurusan.</b-form-invalid-feedback>
              </b-input-group>
            </b-col>
            <b-col lg="5">  
                <b-row class="justify-content-center mb-2">
                  <button class="btn btn-primary mr-1" @click.stop.prevent="pilihJurusan(1)" v-if="(filterAgenJurusan=='JURUSAN')">
                    <i class="fa fa-check-square"></i> Pilih Semua
                  </button>
                  <b-button class="btn btn-primary mr-1" @click.stop.prevent="pilihJurusan(0)" v-if="(filterAgenJurusan=='JURUSAN')">
                    Bersihkan Pilihan
                  </b-button>
                </b-row>
            </b-col>
          </b-row>  
          <b-card v-if="(filterAgenJurusan=='JURUSAN')">
              <b-form-checkbox-group
                id="checkbox-group-2" size="sm" 
                v-model="jurusanSelected"
              >
                <b-form-checkbox
                  v-for="item in koranjurusan"
                  :value="item.jurusan_id"
                  :key="item.index"
                  class="col-5 text-small" 
                >{{item.jurusan_code+' | '+item.jurusan_name}}</b-form-checkbox>
              </b-form-checkbox-group>
          </b-card>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Agen/Langganan"
      :centered="true"
    >
      <lku-customerkoran customer_group='KORAN' @click="onSelectKoranCust"></lku-customerkoran>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>



<script>
import { validationMixin } from "vuelidate";
import { required, minValue, minLength } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
import moment from "moment";
import Loading from "vue-loading-overlay";
import crud from "../../apis/crud";
import koran_report from "../../apis/koran_report";
// import koran_kiriman from "../../apis/koran_kirim_pesanan";
import lkuCustomerkoran from "../lookup/lkuKoranCust";

toastr.init();

export default {
  components: { Loading,lkuCustomerkoran },
  mixins: [validationMixin],
  validations: {
    model: {
      tanggal: { required },
      koliNormal: { required, minValue: minValue(1) },
      koliMinimum: { required },
      koliToleransi: { required },
      section_no: { required }
    }
  },
  data() {
    return {
      isLoading: false,
      horizontal: true,
      saveEnabled: true,
      lkuKoranCustShow: false,
      lkuKoranSalesShow: false,
      lkuKoranColectorShow: false,
      showTableKirimTitipan: false,
      filterAgenJurusan:'AGEN',
      model: {
        tanggal: null,
        customer_id: "",
        koliNormal: 1,
        koliMinimum: 0,
        koliToleransi: 0,
        isPrintedForm: "nonPrinted",
        jurusanId: [],
        section_no: 1,
        sectionPrinted: 1
      },
      sectionPrinted:1,
      isPrintedForm:0,
      customer_info:'',
      allJurursan: false,
      findJurusan: "",
      findPercetakan: "",
      koranjurusanRec: [],
      koranjurusan: [],
      jurusanSelected: [],
      showReport: false,
      reportUrl: null,
      isRequiredJurusan: false,
      options_section_no: [
        { value: null, text: "Pilih Section", disabled: true },
        { value: 1, text: "Sect. 1" },
        { value: 2, text: "Sect. 2" },
        { value: 3, text: "Sect. 3" },
        { value: 4, text: "Sect. 4" }
      ]
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    renderJurusan() {
      return {
        findJurusan: this.findJurusan.trim() || "",
        findPercetakan: this.findPercetakan.trim() || ""
      };
    },
    needJurusan(val) {
      return {
        jurusan: this.model.jurusanId,
        customer_id: this.model.customer_id
      };
    },
    getSetinganKoli() {
      return { section_no: this.model.section_no, tanggal: this.model.tanggal };
    }
  },
  watch: {
    renderJurusan(val) {
      const { findJurusan, findPercetakan } = val;
      if (findJurusan === "" && findPercetakan === "") {
        this.koranjurusan = JSON.parse(JSON.stringify(this.koranjurusanRec));
        // const jrs = this.koranjurusan.map(x => x.jurusan_id);
        // this.jurusanSelected = jrs;
        // this.allJurursan = true;
      } else {
        let result = JSON.parse(JSON.stringify(this.koranjurusanRec));

        result = result.filter(function(x) {
          const txtNameJrs = x.jurusan_name.toUpperCase();
          const txtKodeJrs = x.jurusan_code.toUpperCase();
          const findJurusanTxt = findJurusan.toUpperCase();
          return (
            txtNameJrs.indexOf(findJurusanTxt) !== -1 ||
            txtKodeJrs.indexOf(findJurusanTxt) !== -1
          );
        });

        // result = result.filter(function(x) {
        //   const txtPercetakan = x.percetakan_name.toUpperCase();
        //   const findPercetakanTxt = findPercetakan.toUpperCase();
        //   return txtPercetakan.indexOf(findPercetakanTxt) !== -1;
        // });

        // const jrs = result.map(x => x.jurusan_id);
        // this.allJurursan = true;
        // this.jurusanSelected = jrs;
        this.koranjurusan = result;
      }
    },
    needJurusan({ jurusan = [], customer_id }) {
      if (jurusan.length > 0) {
        this.isRequiredJurusan = false;
      } else {
        if ((customer_id !== "") || (this.filterAgenJurusan=='AGEN')) {
          this.isRequiredJurusan = false;
        } else {
          this.isRequiredJurusan = true;
        }
      }
    },
    async getSetinganKoli(obj) {
      const { section_no, tanggal } = obj;
      if (tanggal !== null && section_no !== null) {
        const resp = await koran_report.getKoranSetingan(obj);
        const data = resp[0];
        if (data) {
          this.model.koliNormal = data.qty_normal || 0;
          this.model.koliMinimum = data.qty_minimum || 0;
          this.model.koliToleransi = data.qty_tolerance || 0;
        } else {
          this.model.koliNormal = 0;
          this.model.koliMinimum = 0;
          this.model.koliToleransi = 0;
        }
      }
    }
  },
  created: async function() {
    const [a] = await Promise.all([
      crud.list({ tablename: "vwkoranjurusan", limit: 1000 })
    ]);
    this.koranjurusanRec = a;
    this.koranjurusan = JSON.parse(JSON.stringify(this.koranjurusanRec));
  },
  methods: {
    iframeDidLoad() {
      alert("Done");
    },
    onSelectKoranCust(_selected) {
      this.customer_info = `${_selected.CustCode + " | " + _selected.CustName}`;
      this.model.customer_id = _selected.customer_id;
      this.lkuKoranCustShow = false;
    },    
    pilihJurusan(val) {
      if (val) {
        this.koranjurusan.forEach(element => {
          this.jurusanSelected.push(element.jurusan_id);
        });
        this.allJurursan=true;
      } else {
        this.jurusanSelected = [];
        this.allJurursan=false;
      }
    },    
    print: async function() {
      if (this.filterAgenJurusan=='AGEN') {
        this.model.jurusanId = '';
      } else {
        this.model.customer_id='';
        //  this.model.jurusanId = JSON.stringify(this.jurusanSelected);
         this.model.jurusanId = this.jurusanSelected.join(',');
      }
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.isLoading = true;
          const data = JSON.parse(JSON.stringify(this.model));
          data.tanggal=moment(this.model.tanggal).format('YYYY-MM-DD');
          const resp = await koran_report.fakturKirimKoli(data);
          // const [resp,_void] = await Promise.all([koran_report.fakturKirimKoli(this.model),koran_report.koranSetinganSave(this.model)]);
          this.isLoading = false;
          this.reportUrl = resp;
          this.showReport =true;
        } catch (error) {
          this.isLoading = false;
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }   
        }
      }
    },

    clearFilter: function() {
      this.findJurusan = "";
      this.findPercetakan = "";
    },
    close() {
      router.push({ name: "koran.home" });
    },
    clearModel() {}
  }
};
</script>